export default __webpack_public_path__ + "static/media/rehack-cover.5cfe3cc7.png";